export default __webpack_public_path__ + "button_scribbler.bf6867.svg";